
























































































export default function (Component) {
  Component.options.__source = "src/components/common/multiImgUpload.vue"
}
